<div class=" w-100 h-100 CallArrivalContentContainer">
    <div *ngIf="!noData && dataLoadSuccess" class="content">
        {{hourInterval}} <span cvLocalizedText langSection="CXOne_Call_Arrival_Module" langKey="Hours_Before_To">hours
            before to</span> {{endDateTime}}
    </div>
    <div class="w-100 h-100 graph">
        <app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
        <canvas baseChart *ngIf="chartConfig && !noData && dataLoadSuccess" class="callArrivalGraph" width="400px" height="225px"
            [type]="chartConfig.type" [legend]="chartConfig.options.plugins.legend.display"
            [datasets]="chartConfig.data.datasets" [labels]="chartConfig.data.labels" [options]="chartConfig.options"
            [plugins]="chartConfig.plugins">
        </canvas>
    </div>
</div>